export const CommonStyles = {
  pageWrapper:
    "flex min-h-screen w-full min-w-0 flex-1 flex-col overflow-x-hidden bg-slate-50 px-4 pb-8 pt-16 sm:px-6 xl:px-8 xl:pt-6",
};
